import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LineTransitService } from './line-transit.service';

@NgModule({
  imports: [CommonModule],
  providers: [LineTransitService],
})
export class LineTransitDataAccessModule {}
